import axios from 'axios';

export default async function getCompanyGroupCompanies({
  accessToken,
  companyGroupId,
  page = 0,
  pageSize = 10,
  query = '',
  setIsFetching,
  setTokenLikeExpired,
}) {
  try {
    if (setIsFetching) setIsFetching(true);

    const { data } = await axios.get(
      `${process.env.REACT_APP_COMPANIES_API_URL}/group-companies/${companyGroupId}?page=${page}&pageSize=${pageSize}&query=${query}`,
      {
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    return data;
  } catch (err) {
    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();

    return null;
  }
}
